<template>
	<b-container>
		<div v-if="is_alert">
			<template v-for="alert in alerts">
				<b-row v-bind:key="alert.id">
					<b-col>
						<b-alert
							dismissible
							@dismissed="delete_alert(alert.id)"
							:variant="alert.variant"
							show
						>
							{{ alert.msg }}
						</b-alert>
					</b-col>
				</b-row>
			</template>
		</div>
	</b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["alerts", "is_alert"])
	},
	methods: {
		delete_alert(alert_id) {
			this.$store.dispatch("delete_alert", alert_id);
		}
	}
};
</script>

<style scoped></style>
